import React from 'react';
import { Link } from 'react-router-dom';
import TrackedLink from '../global/TrackedLink';
import { CTA_IDS, CTA_LOCATIONS } from '../../lib/analytics.constants';

const proyectos = [
    {
        id: 'dez',
        name: "dez",
        modelo: "Built for Equity",
        description: "Primera plataforma paraguaya de descuentos que conecta a usuarios con promociones reales de bancos y marcas.",
        rol: "Desarrollo completo, diseño, arquitectura y operación.",
        url: "https://dez.com.py",
        hasUrl: true,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
        ),
    },
    {
        id: 'moodpy',
        name: "MoodPy",
        modelo: "B4E interno",
        description: "Plataforma de bienestar emocional que permite a pacientes registrar su estado diario y a psicólogos gestionar y seguir la evolución de sus pacientes.",
        rol: "Diseño, arquitectura, backend y mobile.",
        url: "https://moodpy.com/",
        hasUrl: true,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
        ),
    },
    {
        id: 'buscodepto',
        name: "Buscodepto",
        modelo: "Revenue Share",
        description: "Plataforma inmobiliaria paraguaya para alquiler y compra de departamentos, sin garante ni comisión para el inquilino y con proceso 100% digital.",
        rol: "Escalamos la plataforma sin alcance fijo, transicionándola de un producto estancado a una solución robusta y en uso, sumando nuevos modelos de negocio y enfoques de producto.",
        url: "https://buscodepto.net/",
        hasUrl: true,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01" />
            </svg>
        ),
    },
    {
        id: 'circular',
        name: "Circular",
        modelo: "Financiado",
        description: "Primera plataforma paraguaya de compra y venta que intermedia entre compradores y vendedores para garantizar transacciones seguras y confiables.",
        rol: "Diseño, arquitectura, backend y mobile.",
        url: null,
        hasUrl: false,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
        ),
    },
];

export default function ProyectosDestacados() {
    return (
        <section className="py-16 px-0">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="text-center mb-12">
                    <div className="flex justify-center">
                        <p className="w-fit text-[10px] font-medium uppercase tracking-[0.2em] text-[#11b36d] bg-[#11b36d]/10 border border-[#11b36d]/20 rounded-full px-3 py-1 mb-5">Casos reales</p>
                    </div>
                    <h2 className="text-3xl font-thin tracking-tight sm:text-4xl mb-4 text-[#0b2b40] dark:text-white">
                        Ideas con nuestros <span className="text-gradient text-short">modelos</span>
                    </h2>
                    <p className="text-slate-500 dark:text-slate-400 font-light max-w-2xl mx-auto">
                        Algunos proyectos donde aplicamos nuestros{' '}
                        <Link to="/modelos" className="text-[#11b36d] hover:underline transition-colors">modelos de trabajo</Link>
                    </p>
                </div>

                {/* Projects Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {proyectos.map((proyecto) => (
                        <div
                            key={proyecto.id}
                            className="group bg-white dark:bg-[#111111] border border-gray-100 dark:border-white/[0.07] hover:border-[#11b36d]/40 rounded-2xl p-6 transition-colors duration-300 flex flex-col"
                        >
                            {/* Icon + Name row */}
                            <div className="flex items-start justify-between mb-4">
                                <div className="flex items-center gap-3">
                                    <div className="inline-flex items-center justify-center p-2.5 rounded-lg bg-[#11b36d]/10 border border-[#11b36d]/20 text-[#11b36d]">
                                        {proyecto.icon}
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-medium text-[#0b2b40] dark:text-white">
                                            {proyecto.name}
                                        </h3>
                                        <span className="text-xs text-[#11b36d] font-medium">{proyecto.modelo}</span>
                                    </div>
                                </div>
                                {proyecto.hasUrl && (
                                    <a
                                        href={proyecto.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-slate-400 hover:text-[#11b36d] transition-colors"
                                        title="Visitar sitio"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                    </a>
                                )}
                            </div>

                            {/* Description */}
                            <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed mb-4 flex-grow">
                                {proyecto.description}
                            </p>

                            {/* Role */}
                            <div className="pt-4 border-t border-gray-100 dark:border-white/[0.06]">
                                <p className="text-xs text-slate-400 dark:text-slate-500 mb-1 font-medium uppercase tracking-wider">
                                    Rol de eien
                                </p>
                                <p className="text-sm text-slate-600 dark:text-slate-400">
                                    {proyecto.rol}
                                </p>
                            </div>

                            {/* Visit Button */}
                            {proyecto.hasUrl && (
                                <a
                                    href={proyecto.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-4 inline-flex items-center gap-2 text-sm text-[#11b36d] font-medium hover:underline transition-colors"
                                >
                                    Visitar proyecto
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                    </svg>
                                </a>
                            )}
                        </div>
                    ))}
                </div>

                {/* CTA */}
                <div className="text-center mt-12">
                    <div className="inline-flex flex-col sm:flex-row items-center gap-4 px-8 py-6 bg-white dark:bg-[#111111] border border-gray-100 dark:border-white/[0.07] rounded-2xl">
                        <p className="text-slate-600 dark:text-slate-300 font-light">
                            ¿Querés que tu proyecto esté acá?
                        </p>
                        <TrackedLink to="/agendar" ctaId={CTA_IDS.PROJECTS_AGENDAR} ctaLocation={CTA_LOCATIONS.PAGE_CTA}>
                            <button className="inline-flex items-center gap-2 bg-[#11b36d] text-white px-6 py-3 rounded-full font-semibold text-sm hover:bg-[#0ea060] shadow-[0_2px_8px_rgba(17,179,109,0.22),inset_0_1px_0_rgba(255,255,255,0.12)] hover:shadow-[0_4px_14px_rgba(17,179,109,0.32),inset_0_1px_0_rgba(255,255,255,0.12)] transition-all duration-200">
                                Contanos tu idea
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </button>
                        </TrackedLink>
                    </div>
                </div>
            </div>
        </section>
    );
}
